document.addEventListener('DOMContentLoaded', function() {
  const sizeMap = {
    'XS': 'XS',
    'SM': 'S',
    'MD': 'M',
    'LG': 'L',
    'XL': 'XL',
    'XXL': 'XXL'
  };

  function replaceSizes(root) {
    root.querySelectorAll('.variant-option__button-label__text, .cart-items__variant dd').forEach(function(el) {
      const text = el.textContent.trim();
      const key = Object.keys(sizeMap).find(k => text === k || text.startsWith(k + ' -'));
      if (key && sizeMap[key] !== key) {
        el.textContent = text.replace(key, sizeMap[key]);
      }
      el.setAttribute('data-size-ready', 'true');
    });
  }

  replaceSizes(document);

  let timeout;
  const observer = new MutationObserver(function() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      replaceSizes(document);
    }, 0);
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


